module.exports = __webpack_public_path__ + "static/img-step-2@3x-f830f518c9ace45cfec402087bd38037.png";